module.exports = __webpack_public_path__ + "static/media/ClickToPayLabel.2ffc6592.png";